/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApplicationStatus } from './application-status';


export interface ApplicationDto { 
    id: string;
    lotteryId: string;
    status: ApplicationStatus;
    createdAt?: string;
    withdrawnManually: boolean;
    method: ApplicationDto.MethodEnum;
    logNr?: string;
    nycStatusLabel?: string;
    failureReason?: string;
    userId: string;
}
export namespace ApplicationDto {
    export const MethodEnum = {
        initial_auto_apply: 'initial-auto-apply',
        auto_apply: 'auto-apply',
        auto_apply_after_changes: 'auto-apply-after-changes',
        initial_manual_apply: 'initial-manual-apply',
        manual_apply: 'manual-apply',
        initial: 'initial',
        manual: 'manual'
    } as const;
    export type MethodEnum = typeof MethodEnum[keyof typeof MethodEnum];
}


